import { http } from './http';
import type { CarLog } from '../types/api';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

/**
 * ✅ ดึง Logs ของรถ
 * @param carId รหัสรถ
 * @param params ตัวเลือกกรอง เช่น { start: '2025-10-20', end: '2025-10-28' }
 */
export const listCarLogs = async (
  carId: number,
  params?: { start?: string; end?: string }
): Promise<CarLog[]> => {
  const { data } = await http.get<ApiResponse<CarLog[]>>(`/cars/${carId}/logs`, {
    params, // ✅ ส่ง query start / end ไปยัง backend
  });

  if (!data.success || !data.data) {
    throw new Error(data.error || 'โหลด Log ไม่สำเร็จ');
  }

  return data.data;
};

/**
 * ✅ ลบ Log ทีละแถว
 */
export const deleteCarLog = async (logId: number): Promise<void> => {
  const { data } = await http.delete<ApiResponse<null>>(`/cars/logs/${logId}`);
  if (!data.success) {
    throw new Error(data.error || 'ลบ Log ไม่สำเร็จ');
  }
};
